<script setup>
import { useAttrs } from 'vue';

const attrs = useAttrs();
const logoSrc = '/logo_qogattendant.png';
</script>

<template>
  <img v-bind="attrs" :src="logoSrc" alt="Qog Attendant" />
</template>
